import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc049486"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "og_loading"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/images/loading.gif" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "og_metadata"
}
const _hoisted_6 = { class: "meta_description" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.ogLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        (_ctx.og.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.og.thumbnail)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "thumb",
                    style: _normalizeStyle('background-image:url('+_ctx.og.thumbnail+')')
                  }, null, 4))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  (_ctx.og.author)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "[" + _toDisplayString(_ctx.og.author) + "]", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.og.hostname), 1))
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.og.ogTitle), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.og.ogDescription), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}